import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (submitCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = () => {
      return "";
    }

    const fieldNames = [
      "type",
      "concept",
      "id",
      "code",
      "name",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const regex = /^([A-Z]|[0-9]|_|-)*$/

    const schema = yup.object().shape({
      "type": yup.string().required(),
      "concept": yup.string().required(),
      "id": yup.string().max(8).required(),
      "code": yup.string().max(8).matches(regex).required(),
      //eslint-disable-next-line
      "name": yup.string().max(40).matches(/^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\/\.\(\)\%_ -]+$/).required(),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const submit = async () => {
    if (await dataIsValid()) {
      submitCallback(formData);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const formatValue = (value, fieldName) => {
    if (fieldName === "code") {
      return value.length > 0 ? value.replace(/\s/g, "").toUpperCase() : "";
    }

    return value;
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "type") {
      setFormData({
        ...formData,
        [fieldName]: formatValue(value, fieldName),
        concept: "",
      })
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: formatValue(value, fieldName),
    })
  }

  return { formData, setFormValue, submit };
}

export default useHandleForm;
